<app-header></app-header>

<div class="container main-container">

  <div class="container change-password">
    <form name="change-password">
      <h2 class="change-password__title">{{ 'CHANGE_PASSWORD.TITLE' | translate }}</h2>

      <div class="profile-container">
        <div class="profile-container__left">

          <div class="form-group">
            <label for="oldPwd">{{ 'CHANGE_PASSWORD.OLD_PASSWORD' | translate }}</label>
            <input [type]="typePassword[0]" required name="oldPwd" autocomplete="current-password"
                                                                   [(ngModel)]="oldPassword" class="form-control pwdField">
            <img class="pointer login-modal__show-password" width="24" height="24" alt="{{ 'COMMON.CLOSE' | translate }}"
                                                                       (click)="togglePassword(0)" src="assets/img/remove_red_eye.svg">
          </div>

          <div class="form-group">
            <label for="newPwd">{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }}</label>
            <input [type]="typePassword[1]" required name="newPwd" autocomplete="new-password" [(ngModel)]="newPassword" class="form-control pwdField">
            <img class="pointer login-modal__show-password" width="24" height="24" alt="{{ 'COMMON.CLOSE' | translate }}"
                                                                       (click)="togglePassword(1)" src="assets/img/remove_red_eye.svg">
          </div>

          <div class="form-group">
            <label for="newPwdRepeat">{{ 'CHANGE_PASSWORD.REPEAT_PASSWORD' | translate }}</label>
            <input [type]="typePassword[2]" required name="newPwdRepeat" autocomplete="new-password" minlength="8" [(ngModel)]="repeatPassword" class="form-control pwdField">
            <img class="pointer login-modal__show-password" width="24" height="24" alt="{{ 'COMMON.CLOSE' | translate }}"
                                                                       (click)="togglePassword(2)" src="assets/img/remove_red_eye.svg">
          </div>

          <div class="mg-5" *ngIf="loader.count > 0"><loader-throbber></loader-throbber></div>

          <div class="button-container">
            <button class="btn appColorBackground" [style.backgroundColor]="eventData['mainColor']" type="button" (click)="changePasswordBtn()" [disabled]="disableForm() || !passwordIsValid(newPassword)">{{ 'CHANGE_PASSWORD.SAVE' | translate }}</button>
          </div>

          <div class="errorMessage" *ngIf="alertMessage">
            <div>{{ alertMessage | translate }}</div>
          </div>
          <div class="errorMessage" *ngIf="passwordErrorMessage">
            <div>{{ passwordErrorMessage | translate }}</div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<app-footer *ngIf="loader.count < 1"></app-footer>
